import { FC, useEffect } from 'react';
import { css } from '@emotion/react';
import { useInView } from 'react-intersection-observer';
import { CallIntelPatientInsightPromo } from '@frontend/call-intel-assets';
import { generateTrackingId, type TrackingOptions } from '@frontend/call-intel-core';
import { pendo } from '@frontend/tracking';
import { theme } from '@frontend/theme';
import { TRACKING_BASE } from '../../constants';
import { TeaserCard } from './teaser-card';

interface PatientInsightTeaserVariantAProps {
  locationId?: string;
  onViewDemo?: () => void;
  onDismiss?: () => void;
}

const TRACKING_CONFIG: TrackingOptions = {
  ...TRACKING_BASE,
  prefix: 'call-intel-patient-insight-teaser',
  abTestGroup: 'variant-a',
};

export const PatientInsightTeaserVariantA: FC<PatientInsightTeaserVariantAProps> = ({
  locationId,
  onViewDemo,
  onDismiss,
}) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      pendo.track(generateTrackingId({ ...TRACKING_CONFIG, context: 'visible' }));
    }
  }, [inView]);

  return (
    <TeaserCard innerRef={ref} data-testid='patient-insight-teaser' data-variant='a'>
      <TeaserCard.Header />
      <TeaserCard.Body>
        <TeaserCard.Description />
        <TeaserCard.FeatureChips />
        <div css={styles.illustrationWrapper}>
          <CallIntelPatientInsightPromo />
        </div>
      </TeaserCard.Body>

      <TeaserCard.ActionBar
        locationId={locationId}
        onViewDemo={onViewDemo}
        onDismiss={onDismiss}
        trackingOptions={TRACKING_CONFIG}
      />
    </TeaserCard>
  );
};

const styles = {
  illustrationWrapper: css`
    background-color: ${theme.colors.neutral5};
    border-radius: ${theme.borderRadius.medium};
    padding: ${theme.spacing(2, 1.5)};
    margin-top: ${theme.spacing(1)};
  `,
};
